import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Col } from 'react-bootstrap';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import { getSeparator } from '../../../api/Layers/layer-operations';

const SEPARATORS = [
  {
    name: 'Comma',
    separator: `,`
  },
  {
    name: 'Point',
    separator: `.`
  },
  {
    name: 'Vertical Bar',
    separator: `|`
  },
  {
    name: 'Colon',
    separator: `:`
  },
  {
    name: 'Semicolon',
    separator: `;`
  }
];

const LayerCSVSeparatorField = ({ layer, layerSubType }) => {
  if (layerSubType === LAYER_SUBTYPES.CSV) {
    const [selectedSeparator, handleSelectedSeparator] = useState(getSeparator(layer));
    return (
      <Form.Row>
        <Form.Group as={Col} xs={10}>
          <Form.Control
            as="select"
            value={selectedSeparator}
            onChange={event => handleSelectedSeparator(event.target.value)}
          >
            <option value="">Other...</option>
            {SEPARATORS.map(({ name, separator }) => {
              return (
                <option value={separator} key={name}>
                  {name}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
        <Form.Group as={Col} xs={2}>
          <Form.Control
            name="separator"
            value={selectedSeparator}
            onChange={event => handleSelectedSeparator(event.target.value)}
          />
        </Form.Group>
      </Form.Row>
    );
  }
  return '';
};

LayerCSVSeparatorField.propTypes = {
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired
};

export default LayerCSVSeparatorField;
